import { useContext } from 'react';
import i18nContext from 'components/i18n-context';
import './CardDetailsHeadRow.scss';

export const CARD_DETAILS_TABLE_HEADER = [
  {
    label: 'cardId'
  },
  {
    label: 'cardNumber'
  },
  {
    label: 'createdAt'
  },
  {
    label: 'blockedAt'
  },
  {
    label: 'blockType'
  },
  {
    label: 'status'
  },
  {
    label: 'accountNumber'
  },
  {
    label: 'actions'
  }
];

export const CardDetailsHeadRow = () => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {CARD_DETAILS_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'card-table-head'}>
          <div className={'card-table-head-block'}>
            <span>{i18n.getMessage(`cardDetails.table.header.${head.label}`)}</span>
          </div>
        </th>
      ))}
    </tr>
  );
};
